import { withFormik } from 'formik';
import Yup from 'yup';

import FormModal from 'buyside/components/presentation/Form/FormModal/formModal';

const UserProfileFormModalContainer = withFormik({
  mapPropsToValues: ({ userProfile }) => ({
    userProfile: { ...userProfile, resume: JSON.parse(userProfile.resume) },
    submitDetector: null
  }),
  validationSchema: ({ validationSchema }) => validationSchema || Yup.object(),
  handleSubmit: (
    { userProfile },
    { props: { update, closeModal }, resetForm, setStatus, setSubmitting }
  ) => {
    update({ userProfile })
      .then(() => {
        closeModal();
        setTimeout(resetForm, 500);
      })
      .catch(() => {
        setStatus({ serverError: true });
        setSubmitting(false);
      });
  },
  enableReinitialize: true
})(FormModal);

export default UserProfileFormModalContainer;
